// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Wasm = function Wasm(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M11.148 9.64l-.376 1.689h1.17L11.51 9.64h-.362z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M9.487 1.5v.07a1.491 1.491 0 01-2.981 0V1.5H1.5v13h13v-13zM7.706 13.109l-.633-3.133h-.016l-.678 3.133h-.871l-.988-4.6h.862l.588 3.133h.01l.707-3.133h.806l.639 3.171h.013l.67-3.171h.845l-1.1 4.6zm4.743 0l-.293-1.024h-1.548l-.226 1.024h-.866l1.114-4.6h1.358l1.349 4.6z"
    }))
  );
};

export default Wasm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Wasm.js
// module id = 1061
// module chunks = 0